/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".login[_ngcontent-%COMP%]{padding:15px}.user-label[_ngcontent-%COMP%]{font-weight:600;font-size:14px}.user-label[_ngcontent-%COMP%]   .role[_ngcontent-%COMP%]{width:100px;display:inline-block}\n/*# sourceMappingURL=login.component.css.map*/"];
export { styles as styles };
